import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import {
  Expertise,
  FAQ,
  GetToKnowVendors,
  Heading,
  PersonalizedHomecare,
  Vendors
} from "./components";

import styles from "./styles.module.scss";

const Services: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Services page</title>
        <meta name="services" content="Humming home's services page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Heading />
      <Expertise />
      <Vendors />
      <GetToKnowVendors />
      <PersonalizedHomecare />
      <FAQ />
      <StartHumming fillColor="primary2" />
    </div>
  );
};

Services.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Services;
